import Main from "../../../../src/events/2021/07/event-winnig/main";
import * as React from 'react';
export default {
  Main,
  React
};